import { UIHeading5, UIText2, UIText1 } from '@cian/ui-kit';
import { IconActionReload16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './OfferMessage.css';

type TOfferMessageProps = {
  isOutcoming: boolean;
  withReload: boolean;
  formattedAddress: string;
  formattedInfo: string;
  formattedPrice: string;
  formattedOldPrice?: string;
  formattedText: React.ReactNode | null;
  shareUrl: string;
  photoUrl?: string;
  onReload(): void;
  onClick(): void;
};

export const OfferMessage: React.FC<TOfferMessageProps> = ({
  isOutcoming,
  withReload,
  formattedAddress,
  formattedInfo,
  formattedPrice,
  formattedOldPrice,
  formattedText,
  shareUrl,
  photoUrl,
  onReload,
  onClick,
}) => {
  const handleMouseDown = (event: React.MouseEvent<HTMLAnchorElement>) => {
    // Не выполнять событие если клик произошел не колесиком или левой кнопкой
    if (event.button !== 0 && event.button !== 1) {
      return;
    }
    // Для клика левой кнопкой мыши и колесиком
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      className={classNames(styles['container'], withReload && !photoUrl && styles['container-short'])}
      data-name={`OfferMessage_${isOutcoming ? 'outcoming' : 'incoming'}`}
    >
      {photoUrl && (
        <a className={styles['image-container']} onMouseDown={handleMouseDown} href={shareUrl} target="_blank">
          <img data-name="OfferMessage_image" src={photoUrl} className={styles['image']} alt="Фото объявления" />
          {withReload && onReload && (
            <div onClick={onReload} className={styles['image-reload-button']}>
              <IconActionReload16 color="icon-inverted-default" />
            </div>
          )}
        </a>
      )}
      {withReload && onReload && !photoUrl && (
        <div onClick={onReload} className={styles['reload-button']}>
          <IconActionReload16 color="icon-inverted-default" />
        </div>
      )}
      <a onMouseDown={handleMouseDown} href={shareUrl} className={styles['content']} target="_blank">
        <div className={styles['price']} data-name="OfferMessage_price">
          <UIHeading5 color={isOutcoming ? 'text-inverted-default' : 'text-primary-default'}>
            {formattedPrice}
          </UIHeading5>
          <s
            className={classNames(
              styles['formatted_old_price'],
              isOutcoming && styles['formatted_old_price_outcoming'],
            )}
          >
            <UIText2 color={isOutcoming ? 'white_60' : 'gray60_100'}>{formattedOldPrice}</UIText2>
          </s>
        </div>
        <div className={styles['info']}>
          <UIText2 color={isOutcoming ? 'text-inverted-default' : 'gray60_100'} data-name="OfferMessage_info">
            {formattedInfo}
          </UIText2>
          <UIText2 color={isOutcoming ? 'text-inverted-default' : 'gray60_100'} data-name="OfferMessage_address">
            {formattedAddress}
          </UIText2>
        </div>
      </a>

      {formattedText && (
        <div className={styles['text_block']}>
          <div className={styles['text_separator']}></div>
          <div className={styles['text_message']}>
            <span data-name="ChatMessageLayout_text" onClick={onClick}>
              <UIText1 color={isOutcoming ? 'text-inverted-default' : 'text-primary-default'}>{formattedText}</UIText1>
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
